import { useKeycloak } from "@react-keycloak/web";
import LoadingScreen from "components/UtilsComponent/LoadingScreen";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTokenParsed } from "store/auth/auth-store";

export const ConfirmLoginAfterKeycloakScreen: React.FC = () => {
  const { initialized, keycloak } = useKeycloak();
  const navigate = useNavigate();
  const { setTokenParsed } = useTokenParsed();

  useEffect(() => {
    if (initialized) {
      if (keycloak?.authenticated) {
        setTokenParsed(keycloak?.tokenParsed);
        navigate("/app/dashboard", {
          replace: true,
          state: { from: window.location.pathname },
        });
      } else {
        navigate("/auth/login", {
          replace: true,
          state: { from: window.location.pathname },
        });
      }
    }
  }, [initialized, keycloak?.authenticated, navigate]);

  return <LoadingScreen />;
};

export default ConfirmLoginAfterKeycloakScreen;
